export const columns = [
  {
    Header: 'Número de bolsillo',
    accessor: 'sTarjeta',
    type: 'card',
    toEnd: true,
  },
  {
    Header: 'Colaborador',
    accessor: 'sNombre',
  },
  {
    Header: 'Rut colaborador',
    accessor: 'sRUT',
    type: 'dni',
  },
  {
    Header: 'Centro de costo',
    accessor: 'CentroCosto',
  },
  {
    Header: 'Sucursal',
    accessor: 'Sucursal',
  },
  {
    Header: 'Estado',
    accessor: 'sEstado',
    type: 'status',
  },
  {
    Header: 'Saldo',
    accessor: 'sSaldo',
    type: 'currency',
  },
  {
    Header: '',
    accessor: 'fill_balance',
    type: 'fill_balance',
  },
  {
    Header: 'Monto a descontar',
    accessor: 'nMonto',
    editable: true,
    type: 'currency',
  },
]
